import CTLUnReadCell from "application/components/CTLUnReadCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";

const getUpdateColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "FXO Drop Code",
      accessor: "extension",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      disabled: true,
      dataType: "string",
      width: "6",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Gateway Code",
      accessor: "data",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      width: "6",
      validation: formControl.string().required("Required"),
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
      controlType: "select",
      filterControlType: "select",
      options: {
        keyField: "gwCode",
        keyDescription: "gwCode",
        values: [],
        url: "gateway/listAll/gwCode",
      },
    },
    {
      Header: "Sun",
      accessor: "dsun",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "1.7",
      controlType: "checkbox",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Mon",
      accessor: "dmon",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "1.7",
      controlType: "checkbox",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "Tue",
      accessor: "dtue",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "1.7",
      controlType: "checkbox",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "Wed",
      accessor: "dwed",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "1.7",
      controlType: "checkbox",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Thu",
      accessor: "dthu",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "1.7",
      controlType: "checkbox",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "Fri",
      accessor: "dfri",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "1.7",
      controlType: "checkbox",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "Sat",
      accessor: "dsat",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "1.7",
      controlType: "checkbox",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "From Time",
      accessor: "fromTime",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "date",
      width: "4",
      controlType: "time",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "To Time",
      accessor: "toTime",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "date",
      width: "4",
      controlType: "time",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Time Zone",
      accessor: "timezone",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "4",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Non Business Hour App",
      accessor: "nonworkingApp",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "4",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "Non Business Hour Transfer Number",
      accessor: "nonworkingData",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "4",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "Day Inbound COS",
      accessor: "dayInboundCos",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "4",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
      controlType: "select",
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "inboundCos/list/cos",
      },
    },
    {
      Header: "Day Outbound COS",
      accessor: "dayOutboundCos",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "4",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
      controlType: "select",
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "outboundCos/list/cos",
      },
    },
    {
      Header: "Night Inbound COS",
      accessor: "nightInboundCos",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "4",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
      controlType: "select",
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "inboundCos/list/cos",
      },
    },
    {
      Header: "Night Outbound COS",
      accessor: "nightOutboundCos",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "4",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
      controlType: "select",
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "outboundCos/list/cos",
      },
    },

    {
      Header: "TPI",
      accessor: "tpi",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      width: "4",
      controlType: "checkbox",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];
};

export { getUpdateColumns };
